import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../../../store/app'
import { useDispatch, useSelector } from 'react-redux'
import { ViewIntersetExam, finishExam, masterLov, setUserSpecialFlag, submitAnswer } from '../Utils/slice'
import { useNavigate, useParams } from 'react-router-dom'
import { Form } from 'antd'
import PageSpinner from '../../../../../components/PageSpinner/PageSpinner'
import SkillAssessmentFrom from './SkillAssessmentCommon/SkillAssessmentFrom'
import dayjs from 'dayjs'

/**
 * Renders the component for pending Skill Portrait Exam.
 *
 * @return {JSX.Element} The rendered component.
 */
const SkillAssessmentPending = () => {
    const dispatch: AppDispatch = useDispatch()
    const { id }: any = useParams()
    const allsteps = useSelector((state: RootState) => state.WEBPROFILE.bothExamData)
    const [current, setCurrent] = useState(0);
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [btnLoading, setBtnLoading] = useState(false);
    const decodedDataId = atob(id);
    const [allMaster, setAllMaster] = useState()

    const userDetail = useSelector((state: RootState) => state.AUTH.userDetail)

    useEffect(() => {

        // Api to be called when the component mounts
        const fetchData = async () => {
            try {
                const data = await dispatch(ViewIntersetExam(decodedDataId));

                if (data.data.exam_status == 4) {
                    navigate('/skill-assessment-exam/' + id);
                    return 0;
                }
                const tempArray: any = {};
                const uniqueMasterTypes = Array.from(new Set(data.data.questions.map((item: any) => item.type === 2 && item.master_type)));

                if (uniqueMasterTypes.length > 0) {
                    for (const item of uniqueMasterTypes) {
                        if (typeof item === "string") {
                            try {
                                const result = await dispatch(masterLov(item));
                                tempArray[item] = result.data;
                            } catch (error) {
                                error
                            }
                        }
                    }
                }
                setAllMaster(tempArray)

                if (data?.data?.attends?.length > 0) {
                    const questions = data.data.questions;
                    const attendsQue = data.data.attends;
                    const findWithoutAnswer = questions?.filter((item: any) => !attendsQue.some((item2: any) => item.id === item2.question_id));
                    const findIndex = questions?.findIndex((item: any) => item?.id === findWithoutAnswer?.[0]?.id);
                    data.data.attends.map((item: any) => form.setFieldValue(item.question_id, parseInt(item?.answer)));
                    setCurrent(findIndex);
                }

                setLoading(false);
            } catch (error) {
                error
            }
        };

        fetchData();
    }, []);


    const steps = allsteps?.questions?.map((item: any, index: number) => ({
        key: item?.id,
        title: item?.question,
        content: item?.answers,
        question_id: item?.id,
        options: item?.type,
        master_type: item?.master_type,
        index: index + 1,
        description: item?.description
    }));
    const itemsPerPage = 6;
    const startIndex = current;
    const endIndex = current + itemsPerPage;
    const getFirstSix = steps?.slice(startIndex, endIndex);
    const lastArrayData = getFirstSix && getFirstSix[getFirstSix?.length - 1]; // for identity done btn or next btn


    // Function to be called when user has clicked on next button.
    const nextButton = (data: any) => {
        setBtnLoading(true)
        const newArray = [];
        for (const [ques_id, answer] of Object.entries(data)) {
            const findQuestionType = getFirstSix.find((item: any) => item.question_id === Number(ques_id))
            newArray.push({ ques_id, question_type: findQuestionType.options, answer });
        }
        data.answers = newArray
        data.assessment_type = "1"
        const keysToRemove = getFirstSix.map((item: any) => item.question_id);
        keysToRemove.forEach((key: any) => {
            delete data[key];
            return data
        });

        if (steps?.length === lastArrayData?.index) {
            dispatch(submitAnswer(decodedDataId, data)).then(() => {
                completeExam(data)
            }).catch((e: any) => {
                e
                setBtnLoading(false)
            })
        } else {
            dispatch(submitAnswer(decodedDataId, data)).then(() => {
                setBtnLoading(false)
                setCurrent(current + itemsPerPage);
            })
                .catch((e: any) => {
                    e
                    setBtnLoading(false)
                })
        }
    }

    //scroll to top on next button click
    useEffect(() => {
        if (!btnLoading) {
            if ((document.body.clientHeight - 4) > window.innerHeight) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    }, [nextButton, btnLoading])

    // Function to be called when user has answered all questions
    const completeExam = (data: any) => {
        data.current_time = dayjs().format('YYYY-MM-DD HH:mm:ss'),
            dispatch(finishExam(decodedDataId, data)).then(() => {


                if (userDetail?.profile_flag == 1) {
                    var specialProfileFlagRequest = {
                        user_id: userDetail.id,
                        flag: 0,
                        type: 2
                    }
                    dispatch(setUserSpecialFlag(specialProfileFlagRequest)).then(() => {
                        navigate("/dashboard")
                        setBtnLoading(false)
                    });
                }
                else {
                    navigate("/dashboard")
                    setBtnLoading(false)

                }


            })
                .catch((e: any) => {
                    e
                    setBtnLoading(false)
                })

    }

    // Function to be called when user has clicked on previous button to show previous 6 questions
    const prev = () => {
        setCurrent(current - 1)

    }

    // validate form fields after clicking on next button
    const validateForm = () => {
        form.validateFields()
    };
    return !loading && allsteps ? (
        <SkillAssessmentFrom
            steps={steps}
            nextButton={nextButton}
            form={form}
            current={current}
            setCurrent={setCurrent}
            prev={prev}
            getFirstSix={getFirstSix}
            lastArrayData={lastArrayData}
            validateForm={validateForm}
            btnLoading={btnLoading}
            type="pending"
            allMaster={allMaster}
            itemsPerPage={itemsPerPage}

        />
    ) : <PageSpinner />
}

export default SkillAssessmentPending

